import { useEffect, useRef } from "react";

import { AUTO_REFRESH_MS } from "../../constant/agenticPlatform";

/**
 * Initial load + background auto-refresh for the agentic task / stats panels.
 * Calls `refetch` once on mount, then every `AUTO_REFRESH_MS` — skipping a tick
 * while the tab is hidden or `paused` is true (e.g. an upload in flight or a
 * task modal open, so a background poll can't clobber in-progress work).
 *
 * `paused` is read through a ref, so toggling it never re-arms the timer; the
 * interval re-arms only when `refetch`'s identity changes, and is cleared on
 * unmount. `refetch` MUST be a stable callback (useCallback) — a fresh identity
 * each render would thrash the timer.
 */
export const useAutoRefetch = (refetch, paused = false) => {
  const pausedRef = useRef(paused);
  pausedRef.current = paused;

  useEffect(() => {
    refetch();
    const timer = setInterval(() => {
      if (!document.hidden && !pausedRef.current) refetch();
    }, AUTO_REFRESH_MS);
    return () => clearInterval(timer);
  }, [refetch]);
};
